export default "__VITE_ASSET___sG_sko7__"